import React, { Fragment } from 'react';
import SEOMeta from 'containers/SEOMeta';
import FilterList from 'components/layouts/FilterList';
import Filters from './containers/Filters';
import CountryList from './containers/CountryList';
import Pagination from './containers/Pagination';
import CountriesPageHeader from './containers/CountriesPageHeader';

const countries = () => (
  <Fragment>
    <SEOMeta title="Countries" />
    <FilterList
      headerSlot={
        <CountriesPageHeader />
      }
      filterSlot={
        <Filters />
      }
      listSlot={
        <CountryList data-test="geography-list" />
      }
      actionBarSlot={
        <Pagination />
      }
      paginationSlot={
        <Pagination />
      }
    />
  </Fragment>
);

export default countries;

